<!-- 采购收数据操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <purchaseReceiptTemplate ref="purchaseReceiptTemplate"></purchaseReceiptTemplate>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <!-- 采购验收主表单 -->
                           <el-form class="baseForm" id="mainInfo" label-width="150px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2" v-show="isShow" ref="baseForm">
                                 <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-if="formOneValue.isShow == 1">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 收货单号 -->
                                    <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)" slot="append"
                                                     icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="true"></df-date>
                                    <div v-else-if="formOneValue.entityField == 'shtx'">
                                       <input style="display: none;" type="file" id="recordExcel" multiple name="recordExcel" @change="(e) => { fileUpload(2,e.target.files, e.target.files.length, 0, e) }" />
                                       <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                          <li v-for="(val,key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key">
                                             <i class="el-icon-error del" @click="delRemove(2,key)"></i>
                                             <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                             </cusImage>
                                          </li>
                                          <li>
                                             <label for="recordExcel" class="image_label">
                                                <i class="el-icon-plus icon"></i>
                                             </label>
                                          </li>
                                       </ul>
                                       <ul v-else class="upload">
                                          <li>
                                             <label for="recordExcel" class="image_label">
                                                <i class="el-icon-plus icon"></i>
                                             </label>
                                          </li>
                                       </ul>
                                    </div>
                                    <div v-else-if="formOneValue.entityField == 'ysjl'">
                                       <input style="display: none;" type="file" id="recordExcel2" multiple name="recordExcel2" @change="(e) => { fileUpload(3,e.target.files, e.target.files.length, 0, e) }" />
                                       <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                          <li v-for="(val,key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key">
                                             <i class="el-icon-error del" @click="delRemove(3,key)"></i>
                                             <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                             </cusImage>
                                          </li>
                                          <li>
                                             <label for="recordExcel2" class="image_label">
                                                <i class="el-icon-plus icon"></i>
                                             </label>
                                          </li>
                                       </ul>
                                       <ul v-else class="upload">
                                          <li>
                                             <label for="recordExcel2" class="image_label">
                                                <i class="el-icon-plus icon"></i>
                                             </label>
                                          </li>
                                       </ul>
                                    </div>
                                    <el-input v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2" v-show="isShow">
                                 <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-if="formOneValue.isShow == 1">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 系统字段 -->
                                    <div v-if="formOneValue.isReserved == 0">
                                       <span v-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span v-if="sendDataInfo[formOneValue.entityField]">
                                             {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                          </span>
                                       </span>
                                       <div v-else-if="formOneValue.entityField == 'shtx'||formOneValue.entityField == 'ysjl'">
                                          <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                             <li v-for="(val,key) in sendDataInfo[formOneValue.entityField].split(',')" :key="key">
                                                <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                </cusImage>
                                             </li>
                                          </ul>
                                       </div>
                                       <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                    </div>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 查询 -->
                           <el-row id="operateBtn1">
                              <el-col :span="21">
                                 <el-button type="primary" size="mini" @click="lookLicence()">查看证照</el-button>
                                 <el-button type="primary" size="mini" v-if="isShow" @click="tablesq">
                                    收起<i class="el-icon-arrow-up"></i></el-button>
                                 <el-button type="primary" size="mini" v-if="!isShow" @click="tablezk">
                                    展开<i class="el-icon-arrow-down"></i></el-button>
                                 <el-input v-model.trim="filterMsg" placeholder="请输入搜索信息" size="mini" style="width:200px;margin: 0 20px;"></el-input>
                                 <span style="color: red; font-size: 14px;"><i class="el-icon-warning"></i>输入搜索内容过滤</span>
                              </el-col>
                           </el-row>
                           <!-- 验收明细 -->
                           <el-form :inline="true" size="mini">
                              <el-table border style="width: 100%" :data="filterTableData" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                        @selection-change="handleSelectionChange" @expand-change="openChild" size="mini" :height="mxHeight / 2">
                                 <!-- 明细信息 -->
                                 <el-table-column align="center" v-for="(formOneValue) in mxForm" :key="formOneValue.psrgmId" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip
                                                  :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <!-- 显示通用名称 -->
                                       <span v-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(filterTableData[scope.$index][formOneValue.riftField])">{{ filterTableData[scope.$index][formOneValue.entityField]}}</a>
                                       </span>
                                       <!-- 是否双人验收 -->
                                       <el-tag size="mini" v-else-if="formOneValue.entityField == 'bgiIsdcheck'">
                                          {{ filterTableData[scope.$index].bgiIsdcheck == 0 ? '否' : '是' }}
                                       </el-tag>

                                       <span v-else>
                                          {{ filterTableData[scope.$index][formOneValue.entityField] }}
                                       </span>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" label="验收状态" width="110" fixed="right">
                                    <template slot-scope="scope">
                                       <el-link v-if="scope.row.checkState == 0" type="danger" :underline="false">未验收</el-link>
                                       <el-link v-if="scope.row.checkState == 1" type="warning" :underline="false">部分验收</el-link>
                                       <el-link v-if="scope.row.checkState == 2" type="success" :underline="false">验收成功</el-link>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>

                           <div>
                              <!-- 操作 -->
                              <el-row v-if="dataActionBox.actionType != 2" id="operateBtn">
                                 <el-button type="primary" @click="addNewBatch" size="mini">添加</el-button>
                                 <el-button type="primary" @click="delOldBatch" size="mini">删除</el-button>
                                 <input style="display: none;" type="file" id="recordExcel1" multiple name="recordExcel1" @change="(e) => { fileUpload(1,e.target.files, e.target.files.length, 0, e) }" />
                                 <label for="recordExcel1" class="elButton">上传文件</label>
                                 <span style="margin-top:4px;margin-left:10px"
                                       v-if="bachDialogTitle.placeorigin">{{bachDialogTitle.placeorigin +' - ' + bachDialogTitle.manufacturer + ' - ' +bachDialogTitle.drtPacknum +' ' + bachDialogTitle.bgpUnitmeasurement+ ' - ' + bachDialogTitle.bgmName + ' - 装箱规格'+ '(' + bachDialogTitle.packingSpec + ')' }}</span>
                              </el-row>
                              <el-table border class="baseTable" :data="drtchacBatchDetails" size="mini" :height="mxHeight / 2" ref="drtchacBatchDetails">
                                 <!-- 批号信息 drtchacBatchDetails-->
                                 <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedBatchnoIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>

                                 <el-table-column align="center" v-for="(formOneValue, formOneKey) in phForm" :key="formOneKey" :min-width="formOneValue.entityField == 'jybg'?290:formOneValue.fieldWeight"
                                                  :prop="formOneValue.entityField" :label="formOneValue.showField" v-if="formOneValue.isShow == 1">
                                    <template slot="header" slot-scope="scope">
                                       <div class="item-top" style="display: flex;align-items: center;">
                                          <p class="gray-txt">{{ formOneValue.showField }}</p>
                                          <el-popover v-if="formOneValue.entityField == 'schnumber'" placement="top-start" title="抽检规则" width="200" trigger="hover" :content="popTitle">
                                             <i slot="reference" class="el-icon-question" style="font-size: 16px" />
                                          </el-popover>
                                       </div>
                                    </template>
                                    <template slot-scope="scope">

                                       <!-- 验收结论 -->
                                       <el-select :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" v-if="formOneValue.entityField == 'checkcon'"
                                                  @focus="setPhIndex(scope.$index, formOneValue.focusField)" :ref="formOneValue.entityField" :id="formOneValue.entityField" @visible-change="selectChange"
                                                  v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]">
                                          <el-option v-for="(storageRoomValue, storageRoomKey) in ['合格', '不合格']" :key="storageRoomKey" :label="storageRoomValue" :value="storageRoomValue">
                                          </el-option>
                                       </el-select>
                                       <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" @change="$forceUpdate()"
                                                  v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                          <el-option v-for="(item, index) in JSON.parse(formOneValue.formatterContent)" :key="index" :label="item.key" :value="item.value">
                                          </el-option>
                                       </el-select>
                                       <!-- 有效日期 -->
                                       <df-date :isType="true" :isShowLong="true" v-else-if="formOneValue.entityField == 'expidate' && dataActionBox.actionType != 2"
                                                :isdisabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField" :class="formOneValue.entityField" :isLongTime="true"
                                                :isNull="true" @focus="setPhIndex(scope.$index, formOneValue.focusField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, 'expidate')"
                                                v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]">
                                       </df-date>
                                       <!-- 生产日期 -->
                                       <df-date :isShowLong="formOneValue.entityField == 'expidate' ? true : false" v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType != 2"
                                                :isdisabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField" :class="formOneValue.entityField"
                                                :isLongTime="formOneValue.entityField == 'expidate' ? true : false" :isNull="formOneValue.entityField == 'expidate' || formOneValue.entityField == 'prodate' ? true : false"
                                                @focus="setPhIndex(scope.$index, formOneValue.focusField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index,formOneValue.entityField)"
                                                v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]">
                                       </df-date>

                                       <!-- 不合格数量拒收 -->

                                       <el-input v-else-if="formOneValue.entityField == 'rejectnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                 @focus="setPhIndex(scope.$index, formOneValue.focusField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                 v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]" type="number" :min="0" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                       <el-input v-else-if="formOneValue.entityField == 'refnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                 @focus="setPhIndex(scope.$index, formOneValue.focusField)" @blur="queryCount(scope.$index)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                 v-model.number="drtchacBatchDetails[scope.$index][formOneValue.entityField]" type="number" :min="0" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                       <!-- 验收合格数量 -->
                                       <el-input v-else-if="formOneValue.entityField == 'quanumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                 @focus="setPhIndex(scope.$index, formOneValue.focusField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                 v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]" type="number" :min="0" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                       <!-- 抽检数量 -->
                                       <el-input v-else-if="formOneValue.entityField == 'schnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                 @focus="setPhIndex(scope.$index, formOneValue.focusField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                 v-model.number="drtchacBatchDetails[scope.$index][formOneValue.entityField]" type="number" :min="0"></el-input>
                                       <!-- 检索方案 -->
                                       <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField"
                                                 :id="formOneValue.entityField" @focus="setPhIndex(scope.$index, formOneValue.focusField)"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>
                                       <span v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType == 2">
                                          {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                       <div v-else-if="formOneValue.entityField == 'jybg'">
                                          <ul v-if="drtchacBatchDetails[scope.$index][formOneValue.entityField]" class="upload_ul">
                                             <li v-for="(val,key) in drtchacBatchDetails[scope.$index][formOneValue.entityField].split(',')" :key="key">
                                                <i class="el-icon-error del" @click="delRemove(1,key)" v-if="dataActionBox.actionType != 2"></i>
                                                <cusImage style="width: 20px; height: 20px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                </cusImage>
                                             </li>
                                          </ul>
                                       </div>
                                       <el-input v-else :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" v-model="drtchacBatchDetails[scope.$index][formOneValue.entityField]"
                                                 :ref="formOneValue.entityField" @focus="setPhIndex(scope.$index, formOneValue.focusField)"
                                                 @input="input(drtchacBatchDetails[scope.$index][formOneValue.entityField], formOneValue.entityField)"
                                                 @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :maxlength="$store.state.inputLength"></el-input>

                                    </template>
                                    <!--  @blur="isReq(scope.$index, formOneValue, drtchacBatchDetails[scope.$index][formOneValue.entityField])" -->
                                 </el-table-column>
                              </el-table>
                           </div>
                        </div>

                        <!-- 冷链信息 -->
                        <div v-if="scope.index == 1">
                           <el-form size="mini" id="coldInfo" class="baseForm" label-width="150px" :show-message="false">
                              <el-row>
                                 <template v-for="(formOneValue) in scope.row.jurconfigform">
                                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                       <el-input disabled v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                    </el-form-item>
                                 </template>
                              </el-row>
                           </el-form>
                        </div>

                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>

            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="cancelActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>

         </div>

      </div>

      <!-- 第二验收人 -->
      <el-dialog title="选择验收人并且输入验收人的密码" :visible.sync="dialogFormVisible" :append-to-body="true" :close-on-click-modal="false">
         <el-form label-position="top">
            <el-form-item label="账户">
               <el-input v-model="reviewUserInfo.selectIndex"></el-input>
            </el-form-item>
            <el-form-item label="密码">
               <el-input type="password" v-model="reviewUserInfo.passWord"></el-input>
            </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="userVerification()">确 定</el-button>
         </div>
      </el-dialog>

      <!-- new明细提取 -->
      <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
         <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getTiqu" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
import purchaseReceiptTemplate from "@/components/purchaseReceiptTemplate.vue";
export default {
   name: "zdysListAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      ExtractionScheme,
      SearchScheme,
      purchaseReceiptTemplate
   },
   data() {
      //这里存放数据
      return {
         imgUrl: window.global_config.BASE_IMG_URL,
         isShow: true,
         phHeight: 300,
         detailRules1: false, //抽检拦截
         separateDialog: false,
         exTitle: "",
         DialogExtract: false,
         exWidth: "",
         exId: "",
         ppId: "",
         rowindex: 0,
         childindex: 0,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         showTabs: "",
         formDataList: [],
         userOneList: [],
         userTwoList: [], // 验收人
         reviewUserInfo: {
            opmId: "",
            passWord: "",
            selectIndex: '',
         },
         msgDialogVisible: false, //批号
         drtchacBatchDetails: [], //批号项
         phObj: {},
         pschacBatchDetailsObj: {},//初始批号对象
         dialogFormVisible: false, //第二验收
         actionIndex: "",
         storageRoomList: [],
         ishowRew: true,
         // detailsAction:[],
         reviewDetailsData: {},
         msgTabsActive: "addMsg", //明细二级name
         filterMsg: "", //搜索信息
         filterTableData: [], //搜索缓存明细
         bachDialogTitle: {}, //批号弹窗头信息
         selectedBatchnoIndex: 0, //批号选择
         isLoaded: false,
         mxHeight: 0,
         tabForm: [], // 主表单
         mxForm: [], // 明细表单
         footForm: [], //表尾
         phForm: [], // 批号明细
         seTitle: "", //检索
         DialogVisible: false,
         seId: 0,
         seType: "",
         seIndex: 0,
         seWidth: "",
         sField: "",
         fField: "",
         parentSearchData: {},
         inputel: "",
         phIndex: 0,
         popTitle: '',
         selectedRow: [], // 当前已选择行
         selectedDetailsIndex: 0,
         keydownField: '',
         tableIndex: 0,
         newTime: '',
         newDayTime: '',
         openSearchFlag: false,//判断检索方案是明细（false）的还是表单（true）的
         tableKey: 0,
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      filterMsg() {
         //搜索
         this.searchClick();
      },
      "drtchacBatchDetails": {
         handler: function (newValue, oldValue) {
            // this.sendDataInfo.totalCount = 0; //总条目数
            // this.sendDataInfo.totalMoney = 0; // 总金额
            // this.sendDataInfo.totalNumber = 0; // 总数量
            newValue.forEach(async (item, keys) => {
               this.$set(item, 'quanumber', this.$common.updataNum('quanumber', item).quanumber)
               this.$set(item, 'refnumber', this.$common.updataNum('refnumber', item).refnumber)
               this.$set(item, 'schnumber', this.$common.updataNum('schnumber', item).schnumber)
               if (Number(item.quanumber) + item.refnumber + Number(item.rejectnumber) > this.selectedRow[0]?.drtPacknum) {
                  item.quanumber = this.selectedRow[0].drtPacknum - item.refnumber - Number(item.rejectnumber)
               }
               if (item.prodate.toString().substring(item.prodate.toString().length - 3) == '001' || item.expidate.toString().substring(item.expidate.toString().length - 3) == '001') return
               if ((item.prodate > this.newTime) && item.prodate != '') {
                  item.prodate = this.newTime
                  this.$refs.prodate[keys].$forceUpdate()
                  this.$message({
                     message: "生产日期不能大于今日",
                     type: "warning",
                  });
               }
               if (item.prodate != '' && item.glRedate != '' && (item.prodate < item.glRedate)) {
                  item.prodate = ""
                  this.$refs.prodate[keys].$forceUpdate()
                  this.$message({
                     message: "生产日期不能小于注册证发证日期",
                     type: "warning",
                  });
               }
               if ((item.expidate < this.newDayTime) && item.expidate != '') {
                  item.expidate = this.newDayTime
                  this.$refs.expidate[keys].$forceUpdate()
                  this.$message({
                     message: "此商品已经失效，失效范围小于等于当天",
                     type: "warning",
                  });
               }
            });
         },
         deep: true,
      },
      "selectedDetailsIndex": {
         handler: function (newValue, oldValue) {
            if (newValue != oldValue) addEventListener('keyup', this.keyUpEnter)//创建监听键盘事件
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      input(val, a) {
         console.log(val, a);
      },
      //删除随货通行
      delRemove(val, key) {

         switch (val) {
            case 1://质检报告
               var arrDetails = this.drtchacBatchDetails[this.selectedBatchnoIndex].jybg.split(",")
               arrDetails.splice(key, 1)
               this.drtchacBatchDetails[this.selectedBatchnoIndex].jybg = arrDetails.join()
               break;
            case 2://随货同行单
               var arr = this.sendDataInfo.shtx.split(',')
               arr.splice(key, 1)
               this.sendDataInfo.shtx = arr.join()
               break;
            case 3://验收记录
               var arr = this.sendDataInfo.ysjl.split(',')
               arr.splice(key, 1)
               this.sendDataInfo.ysjl = arr.join()
               break;
            default:
               break;
         }

      },
      //上传随货同行 2 上传质检 1
      async fileUpload(val, files, length, index, e) {
         if (length - 1 >= index) {
            const params = {
               file: files[index]
            }
            const response = await this.$http.uploadFile(params, true)
            if (response.status == 200) {
               var arr = []
               if (val == 2) {//随货同行单
                  if (this.sendDataInfo.shtx != undefined && this.sendDataInfo.shtx != "" && this.sendDataInfo.shtx != null) {
                     arr = this.sendDataInfo.shtx.split(',')
                  }
                  arr.push(response.result[0].fileUrl)
                  this.sendDataInfo.shtx = arr.join()
               } else if (val == 3) {//验收记录
                  if (this.sendDataInfo.ysjl != undefined && this.sendDataInfo.ysjl != "" && this.sendDataInfo.ysjl != null) {
                     arr = this.sendDataInfo.ysjl.split(',')
                  }
                  arr.push(response.result[0].fileUrl)
                  this.sendDataInfo.ysjl = arr.join()
               } else if (val == 1) {//质检报告
                  if (this.drtchacBatchDetails[this.selectedBatchnoIndex].jybg != undefined && this.drtchacBatchDetails[this.selectedBatchnoIndex].jybg != "" && this.drtchacBatchDetails[this.selectedBatchnoIndex].jybg != null) {
                     arr = this.drtchacBatchDetails[this.selectedBatchnoIndex].jybg.split(',')
                  }
                  arr.push(response.result[0].fileUrl)
                  this.drtchacBatchDetails[this.selectedBatchnoIndex].jybg = arr.join()
               }
               this.fileUpload(val, files, length, index + 1, e)
            } else {
               e.target.value = ""
               this.$message.error(response.message)
            }
         } else {
            e.target.value = ""
         }
      },
      tabHeight(val) {
         console.log(val);
      },
      async queryCount(index) {
         let cjnum = await this.samplingRulesQueryCount(Number(this.drtchacBatchDetails[index].quanumber) + Number(this.drtchacBatchDetails[index].refnumber) + Number(this.drtchacBatchDetails[index].rejectnumber), this.selectedRow[0].packingSpec,this.selectedRow[0].bgmId) //件数，装箱规格
         console.log(cjnum);
         
         this.drtchacBatchDetails[index].schnumber = cjnum ? cjnum : "";
      },
      getTimestamp() {
         this.newTime = new Date(new Date().toLocaleDateString()).getTime() - 1 * 24 * 3600 * 1000
         this.newDayTime = Number(this.$common.getNewDayTime() * 1 + 86400000)
      },
      closeChild() {
         addEventListener('keyup', this.keyUp)//创建监听键盘事件
      },
      // 监听键盘事件
      keyUp(e) {
         e.preventDefault();
         if (e.keyCode == 40) { // 下键
            // 表格为空，不执行下方 
            if (this.filterTableData.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == this.filterTableData.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                  this.selectedDetailsIndex = 0
               } else { // 正常递增
                  this.selectedDetailsIndex++
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex], false);
                  return;
               }
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         } else if (e.keyCode == 38) { // 上键
            if (this.filterTableData.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                  this.selectedDetailsIndex = this.filterTableData.length - 1
               } else { // 正常递减
                  this.selectedDetailsIndex--
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex], false);
                  return;
               }
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         }
      },
      keyUpEnter(e) {
         e.preventDefault();
         if (e.keyCode == 13) {
            this.$nextTick(() => {
               this.msgCellClick(this.filterTableData[this.selectedDetailsIndex])
               removeEventListener('keyup', this.keyUpEnter)
            });
         }
      },

      // 表格方法
      rowClassName({ row, rowIndex }) {
         let rowName = "",
            findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },

      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false
         });
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },

      // 明细表格点击选中
      clickEvent(row, column, event, params) {
         console.log('点击明细', row)
         this.msgCellClick(row)
         let refsElTable = this.$refs.mxTableRef; // 获取表格对象
         let findRow = {}
         this.selectedDetailsIndex = row.rowIndex
         findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
         //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
         if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(row, false);
            return;
         }
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(row);

      },

      // 保存已选择行
      handleSelectionChange(rows) {
         this.selectedRow = rows; // 保存已选择行
      },
      tablesq() {
         this.isShow = false
         this.getHeight()
      },
      tablezk() {
         this.isShow = true
         this.getHeight()
      },
      setPhIndex(index, fField) {
         this.phIndex = index;
         this.fField = fField;
      },
      // 查看证照
      lookLicence() {
         if (this.sendDataInfo.smId == "") {
            return this.$message({
               message: "请先选择供货单位",
               type: "warning",
            });
         }
         this.$parent.$parent.toDetail(this.sendDataInfo.smId);
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      //明细二级表单展开
      openChild(row) {
         this.childindex = row.in; //
      },
      //明细操作弹窗
      async msgCellClick(row) {
         if (row == undefined) {
            return
         }
         this.drtchacBatchDetails = row.drtchacBatchDetails;
         this.selectedBatchnoIndex = Number(this.drtchacBatchDetails.length - 1)

         this.rowindex = row.in;
         // this.msgDialogVisible = true;
         //批号头
         this.bachDialogTitle.bgmName = row.bgmName;
         this.bachDialogTitle.manufacturer = row.manufacturer;
         this.bachDialogTitle.drtPacknum = row.drtPacknum; //总件数
         this.bachDialogTitle.placeorigin = row.placeorigin;
         this.bachDialogTitle.bgpUnitmeasurement = row.bgpUnitmeasurement; //包装单位
         this.bachDialogTitle.packingSpec = row.packingSpec; //装箱规格


         if (this.drtchacBatchDetails[0].quanumber == "")
            this.drtchacBatchDetails[0].quanumber = row.drtPacknum;
         this.$nextTick(() => {
            removeEventListener('keyup', this.keyUpEnter)
            this.tableNextFocus("batchno", 0);
         });
      },
      //查询
      searchClick() {
         if (this.filterMsg) {
            this.filterTableData = this.sendDataInfo.drtchaDetails.filter((data) =>
               data.bgmName.toLowerCase().includes(this.filterMsg.toLowerCase())
            );
         } else {
            this.filterTableData = this.sendDataInfo.drtchaDetails;
         }
      },
      //提取明细信息
      async getTiqu(val) {
         console.log("提回", JSON.parse(JSON.stringify(val)));
         let obj = val;
         this.DialogExtract = false;
         if (val && val != null) {
            for (let key in obj) {
               if (key == "arrlistbychen") continue;
               this.sendDataInfo[key] = obj[key];
            }
            this.sendDataInfo.drtchaDetails = obj.arrlistbychen;
            this.filterTableData = obj.arrlistbychen;
            this.filterTableData.forEach(item => {
               item.checkState = 0
            })
            this.sendDataInfo.drtchaDetails.forEach((v, i) => {
               v.price = v.price ? this.$common.getDecimalInfo(2, v.price) : 0;
               v.refnumber = v.refnumber ? this.$common.getDecimalInfo(2, v.refnumber) : 0;
               v.money = v.money ? this.$common.getDecimalInfo(3, v.money) : 0;
               v.psmoney = v.psmoney ? this.$common.getDecimalInfo(3, v.psmoney) : 0;
               v.in = i;
               v.checkState = 0
               v.drtchacBatchDetails = [JSON.parse(JSON.stringify(this.phObj))];
            });

            this.addPschacBatch1(true); //重置批号数组
            if (this.sendDataInfo.drtchaDetails.length > 0) this.msgCellClick(this.sendDataInfo.drtchaDetails[0])
            this.$nextTick(() => {
               this.nextFocus(this.seIndex);
               this.selectedDetailsIndex = 0
               let refsElTable = this.$refs.mxTableRef
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]);
            });
         }
      },
      // 提取方案
      openExComponents(e, index) {
         this.DialogExtract = true;
         this.seIndex = index;
         this.exId = e;
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, flag) {
         this.parentSearchData = {}
         removeEventListener('keyup', this.keyUp)
         removeEventListener('keyup', this.keyUpEnter)
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
         this.openSearchFlag = flag ? true : false
         if (type == 'pschaName') {
            this.$set(this.parentSearchData, 'opmAcceptor', 1)
            this.$set(this.parentSearchData, 'opmBuyer', "")
         }
         this.parentSearchData[type] = this.drtchacBatchDetails[type];
      },
      changeInputModel(val) {
         console.log('检索', val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            addEventListener('keyup', this.keyUp)
            this.paramValue(val);
         }
      },
      // 获取冷链表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         this.inputel = el ? el.getElementsByTagName('input') : ''
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "" && this.inputel[index].title != 'second') {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 批号表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            this.tableNextFocus(this.fField, this.phIndex);
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         if (this.openSearchFlag) {
            arr.forEach((item) => {
               this.$set(this.sendDataInfo, item, val[item])
            });
            return
         }
         arr.forEach((item) => {
            this.$set(this.drtchacBatchDetails[this.seIndex], item, val[item])
         });
         this.$nextTick(() => {
            this.drtchacBatchDetails.splice(1, 0)
            this.sendDataInfo.drtchaDetails[this.rowindex]["drtchacBatchDetails"] =
               JSON.parse(JSON.stringify(this.drtchacBatchDetails));
            this.filterTableData[this.rowindex]["drtchacBatchDetails"] = JSON.parse(
               JSON.stringify(this.drtchacBatchDetails)
            );
            this.sendDataInfo.drtchaDetails.splice(1, 0)
            this.filterTableData.splice(1, 0)
            this.tableNextFocus(this.fField, this.seIndex);
         });
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= this.inputel.length - 1) {
            return;
         }
         var aindex = index + 1;
         if (this.inputel[aindex].title == 'second') {
            aindex += 1
         }
         if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
            this.nextFocus(aindex);
            return;
         }
         this.inputel[aindex].focus();
      },
      // 表格切换焦点方法
      tableNextFocus(field, index, type) {
         this.tableIndex = index
         //  if (type == 'expidate') {
         //     if (this.drtchacBatchDetails[index].expidate != undefined && this.drtchacBatchDetails[index].expidate != "" && this.drtchacBatchDetails[index].expidate != null) {
         //        this.$http.pschacheckProdit({ ids: [this.drtchacBatchDetails[index].expidate] }).then(res => {
         //           if (res.status == 300) {
         //              this.$message.warning(res.message)
         //              this.drtchacBatchDetails[index].quanumber = 0
         //              this.drtchacBatchDetails[index].rejectnumber = this.bachDialogTitle.drtPacknum
         //           }
         //        })
         //     }
         //  }
         if (field == "prodate") {
            let ine = document
               .getElementsByClassName("prodate")[index].getElementsByTagName("input")[0];
            ine.focus();
            return;
         } else if (field == "expidate") {
            let ine = document
               .getElementsByClassName("expidate")[index].getElementsByTagName("input")[0];
            ine.focus();
            return;
         }
         if (field == "keydown") {
            var flag = false
            this.phForm.forEach(item => {
               if (item.entityField == "expidate" || item.entityField == 'batchno' || item.entityField == 'prodate') {
                  if (item.isRequired == '1') {
                     if (this.drtchacBatchDetails[0].batchno == '') {
                        if (document.getElementsByClassName('el-message').length == 0) {
                           this.$message({
                              message: "批号不能为空",
                              type: "warning",
                           });
                        }

                        return flag = true
                     }
                  }


               }
            })
            if (flag) {
               return
            }



            if (this.drtchacBatchDetails[index + 1] != undefined) {
               this.$refs["batchno"][index + 1].focus(); //跳退货数量
               this.selectedDetailsIndex = index + 1;
               // this.$nextTick(()=>{
               // 	let refsElTable = this.$refs.mxTableRef
               // 	refsElTable.clearSelection();
               // 	refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
               // })
            } else {

               this.$nextTick(() => {

                  if (this.checkNum()) { //true 所有合格数量
                     // console.log('数量校验通过，进入确定方法')
                     this.addMsgDialog()
                  } else {
                     // console.log('数量校验失败，单条校验方法')
                     if (this.checkOneData()) {
                        this.partCheck()
                        // console.log('单条校验成功,进入添加明细方法')
                        this.addNewBatch();
                     }
                  }


               })
            }
            return;
         }
         this.$refs[field] && this.$refs[field][index].focus();
      },
      // 部分验收操作逻辑
      partCheck() {
         this.sendDataInfo.drtchaDetails[this.rowindex].checkState = 1
         this.filterTableData[this.rowindex].checkState = 1
         this.sendDataInfo.drtchaDetails[this.rowindex]["drtchacBatchDetails"] =
            JSON.parse(JSON.stringify(this.drtchacBatchDetails));
         this.filterTableData[this.rowindex]["drtchacBatchDetails"] = JSON.parse(
            JSON.stringify(this.drtchacBatchDetails)
         );
         this.msgCellClick(this.filterTableData[this.selectedDetailsIndex])
         this.sendDataInfo.drtchaDetails.splice(1, 0)
         this.filterTableData.splice(1, 0)
      },
      handleClickCeShi() {
         this.DialogExtract = true;
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },

      getExtractName(e) {
         this.exTitle = e;
      },


      //批号添加确定
      async addMsgDialog() {
         var num = 0;
         // let kuflag = false;
         // let okflaf = false;
         let prflag = false;
         let cjflag = false;
         let numflag = false
         let splitProductDtoList = [];
         this.drtchacBatchDetails.forEach((item) => {
            let num1 = item.refnumber;
            let num2 = item.quanumber;
            let num3 = item.rejectnumber;
            num += Number(num1) + Number(num2) + Number(num3);
         });
         if (num > Number(this.bachDialogTitle.drtPacknum)) {
            this.$message({
               message: "验收合格数量、不合格数量、拒收数量之和不能大于总件数",
               type: "error",
            });
            return false;
         } else if (num < Number(this.bachDialogTitle.drtPacknum)) {
            this.$message({
               message: "验收合格数量、不合格数量、拒收数量之和不能小于总件数",
               type: "error",
            });
            return false;
         }


         for (let i = 0; i < this.drtchacBatchDetails.length; i++) {
            const v = this.drtchacBatchDetails[i];
            let num1 = v.refnumber;
            let num2 = v.quanumber;
            let num3 = v.rejectnumber;
            let nums = Number(num1) + Number(num2) + Number(num3);
            if (!v.batchno || !v.prodate || !v.expidate) {
               prflag = true;
               break;
            }
            if (this.detailRules1 && v.schnumber <= 0) {
               cjflag = true;
               break;
            }
            if (nums < v.schnumber) {
               numflag = true
               break
            }
         }
         if (numflag) {
            this.$message({
               message: "抽检数量不能大于合格数量、不合格数量、拒收数量之和",
               type: "error",
            });
            return false;
         }
         if (cjflag) {
            this.$message({
               message: "请填写抽检数量",
               type: "error",
            });
            return false;
         }

         //拦截
         for (let j = 0; j < this.drtchacBatchDetails.length; j++) {
            const item = this.drtchacBatchDetails[j];
            splitProductDtoList[j] = {};
            for (const key in item) {
               if (
                  key == "quanumber" ||
                  key == "refnumber" ||
                  key == "rejectnumber" ||
                  key == "prodate" ||
                  key == "expidate"
               ) {
                  splitProductDtoList[j][key] = item[key];
               }
            }
         }
         var responseData = await this.$http.checkAcceptanceLicense({
            formId: this.formDataList[2].jciId,
            psrgdId: this.sendDataInfo.drtchaDetails[this.rowindex].psrgdId,
            bgmId: this.sendDataInfo.drtchaDetails[this.rowindex].bgmId,
            splitProductDtoList: splitProductDtoList,

         });
         if (!responseData || responseData.status != 200) {
            //弹窗 换行提示
            let txtArr = responseData.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
               newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
               confirmButtonText: "确定",
               callback: (action) => { },
            });
            return false;
         }

         this.msgDialogVisible = false;
         this.sendDataInfo.drtchaDetails[this.rowindex]["drtchacBatchDetails"] =
            JSON.parse(JSON.stringify(this.drtchacBatchDetails));
         this.filterTableData[this.rowindex]["drtchacBatchDetails"] = JSON.parse(
            JSON.stringify(this.drtchacBatchDetails)
         );
         this.sendDataInfo.drtchaDetails[this.rowindex].checkState = 2
         this.filterTableData[this.rowindex].checkState = 2
         this.sendDataInfo.drtchaDetails.splice(1, 0)
         this.filterTableData.splice(1, 0)
         // this.$refs.mxTableRef.$forceUpdate()
         // console.log('this.filterTableData', this.filterTableData)
         this.$message({
            message: this.bachDialogTitle.bgmName + "验收成功",
            type: "success",
         });
         this.$refs[this.keydownField][this.tableIndex].blur()
      },

      //取消新增
      cancelActionBox() {
         this.$confirm("将会清除改动的数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$common.delOrderInfo(this.sendDataInfo.psrgmId)
               this.$emit("drawerCancel", 0);
               this.initActionBox();
               this.$refs["sendDataInfo"].resetFields();
            })
            .catch(() => { });
      },

      //确认新增
      async sendDataAction() {
         console.log(this.sendDataInfo)
         this.$refs["sendDataInfo"].validate((valid) => {
            if (valid) {
               let bigFlag = true
               for (let i = 0; i < this.sendDataInfo.drtchaDetails.length; i++) {
                  let allNumber = 0
                  const item = this.sendDataInfo.drtchaDetails[i].drtchacBatchDetails ? this.sendDataInfo.drtchaDetails[i].drtchacBatchDetails : "";
                  if (!item) {
                     this.$message({
                        message: "未拿到明细信息",
                        type: "error",
                     });
                     bigFlag = false
                     break
                  }
                  for (let j = 0; j < item.length; j++) {
                     const v = item[j];//psrgdRecnumber
                     allNumber += Number(v.quanumber)
                     allNumber += Number(v.rejectnumber)
                     allNumber += Number(v.refnumber)
                     //验收合格+拒收+不合格
                  }
                  if (allNumber == 0) {
                     this.filterTableData.forEach(item => {
                        if (item.bgmId == this.sendDataInfo.drtchaDetails[i].bgmId) {
                           this.$set(item, 'checkState', 0)
                           this.tableKey++
                        }
                     })
                     bigFlag = false
                     this.$message({
                        message: "未全部验收",
                        type: "error",
                     });
                     break
                  }
                  if (allNumber != this.sendDataInfo.drtchaDetails[i].drtPacknum) {
                     this.filterTableData.forEach(item => {
                        if (item.bgmId == this.sendDataInfo.drtchaDetails[i].bgmId) {
                           this.$set(item, 'checkState', 1)
                           this.tableKey++
                        }
                     })
                     this.$message({
                        message: "验收合格数量+拒收数量+不合格数量不等于总数量！",
                        type: "error",
                     });
                     bigFlag = false
                     break
                  }
                  if (allNumber < this.sendDataInfo.drtchaDetails[i].drtPacknum) {
                     this.$message({
                        message: "验收合格数量、不合格数量、拒收数量之和不能大于总件数",
                        type: "error",
                     });
                     bigFlag = false
                     break
                  }
                  if (allNumber == this.sendDataInfo.drtchaDetails[i].drtPacknum) {
                     this.filterTableData.forEach(item => {
                        if (item.bgmId == this.sendDataInfo.drtchaDetails[i].bgmId) {
                           this.$set(item, 'checkState', 2)
                           this.tableKey++
                        }
                     })
                  }
                  if (this.sendDataInfo.drtchaDetails[i].checkState != 2) {
                     this.$message({
                        message: "未全部验收",
                        type: "error",
                     });
                     bigFlag = false
                     break
                  }
               }
               if (!bigFlag) return
               for (let i = 0; i < this.sendDataInfo.drtchaDetails.length; i++) {
                  const item = this.sendDataInfo.drtchaDetails[i];
                  item.drtchacBatchDetails.forEach((item1, index) => {
                     this.$set(item1, 'jybg', this.drtchacBatchDetails[index].jybg || "")
                  })
                  if (
                     !item["drtchacBatchDetails"] ||
                     item.drtchacBatchDetails.length <= 0
                  ) {
                     this.$message({
                        message: "请完善 " + item.bgmName + " 的批号信息",
                        type: "error",
                     });
                     break
                  }
               }
               this.sub()
            } else {
               return this.$message({
                  message: "请完善主信息",
                  type: "error",
               });
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         var responseData;
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.drtchaOrderAdd(sendData); //新增
         } else {
            responseData = await this.$http.drtchaUpdate(sendData); //修改
         }
         if (responseData.status == 200) {
            this.$refs["sendDataInfo"].resetFields();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //删除货单
      deleteDetails(index) {
         this.sendDataInfo.drtchaDetails.splice(index, 1);
      },
      // 校验所有数量是否等于总数量
      checkNum() {
         let num = 0;
         let flag = true
         for (let i = 0; i < this.drtchacBatchDetails.length; i++) {
            let v = this.drtchacBatchDetails[i];
            let twoNum = Number(v.quanumber) + Number(v.refnumber) + Number(v.rejectnumber)
            num += twoNum
         }
         flag = num == this.bachDialogTitle.drtPacknum ? true : false
         return flag;
      },
      checkOneData() {
         let num = 0;
         let flag = true
         for (let i = 0; i < this.drtchacBatchDetails.length; i++) {
            let v = this.drtchacBatchDetails[i];
            if (!v.quanumber) {
               this.$message({
                  message: "请输入合理的验收数量",
                  type: "error",
               });
               flag = false
               return;
            }
            let num1 = v.refnumber ? v.refnumber : 0;
            let num2 = v.quanumber ? v.quanumber : 0;
            let num3 = v.rejectnumber ? v.rejectnumber : 0;
            num += Number(num1) + Number(num2) + Number(num3);
            console.log('抽检数量', v.schnumber, 'num', num)
            // if(num>this.drtchacBatchDetails.drtPacknum){
            if (num > this.bachDialogTitle.drtPacknum) {
               this.$message({
                  message: "验收合格数量、不合格数量、拒收数量之和不能大于总件数",
                  type: "error",
               });
               flag = false
               return;
            } else if (v.refnumber == 0 && v.quanumber == 0) {
               this.$message({
                  message: "请输入合理的验收数量",
                  type: "error",
               });
               flag = false
               return;
               // }else if(num == this.drtchacBatchDetails.drtPacknum){
            } else if (v.schnumber > num) {
               this.$message({
                  message: "抽检数量不能大于合格数量、不合格数量、拒收数量之和",
                  type: "error",
               });
               flag = false
               return;
            } else if (v.quanumber == this.bachDialogTitle.drtPacknum) {
               flag = false
               return;
            }
         }
         return flag;
      },
      //添加批号
      addNewBatch() {
         this.addPschacBatch();
      },
      //删除批号
      delOldBatch() {
         if (this.drtchacBatchDetails.length > 1) {
            this.$confirm('确定删除此条明细吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               this.drtchacBatchDetails.splice(this.selectedBatchnoIndex, 1);
               this.sendDataInfo.drtchaDetails[this.rowindex]["drtchacBatchDetails"].splice(this.selectedBatchnoIndex, 1)
               this.filterTableData[this.rowindex]["drtchacBatchDetails"].splice(this.selectedBatchnoIndex, 1)
               this.selectedBatchnoIndex--;
               if (this.checkOneData()) {
                  this.partCheck()
               }
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });
            }).catch(() => { });
         } else {
            this.$message({
               message: "请输入合理信息, 至少保留一项",
               type: "error",
            });
            return false;
         }
         console.log("del");
      },
      addPschacBatch(reset) {
         if (this.sendDataInfo.psrgmId != '') {
            if (!this.checkOneData()) {
               return this.$message({
                  message: "无需新增批号明细",
                  type: "error",
               });
            }
         } else {
            return this.$message({
               message: "请先提取明细",
               type: "error",
            });
         }

         if (reset) {
            this.drtchacBatchDetails = [];
         }
         this.drtchacBatchDetails.push(JSON.parse(JSON.stringify(this.phObj)));

         this.$nextTick(() => {
            this.selectedBatchnoIndex = Number(this.drtchacBatchDetails.length - 1);
            var num = 0
            this.drtchacBatchDetails.forEach((item, index) => {
               if (index != this.selectedBatchnoIndex) {
                  num = Number(item.quanumber) + Number(item.refnumber) + Number(item.rejectnumber) + num
               }
            })
            this.drtchacBatchDetails[this.selectedBatchnoIndex].quanumber = this.selectedRow[0].drtPacknum - num
            this.samplingRulesQueryCount(num, this.selectedRow[0].packingSpec,this.selectedRow[0].bgmId).then(res => {
               if (res.status == 200) {
                  this.drtchacBatchDetails[this.selectedBatchnoIndex].schnumber = res.result
               }
            }) //件数，装箱规格
            this.tableNextFocus("batchno", this.selectedBatchnoIndex);
         });
      },
      addPschacBatch1(reset) {
         if (reset) {
            this.drtchacBatchDetails = [];
         }
         this.drtchacBatchDetails.push(JSON.parse(JSON.stringify(this.phObj)));
         this.$nextTick(() => {
            this.selectedBatchnoIndex = Number(this.drtchacBatchDetails.length - 1);
            this.tableNextFocus("batchno", this.selectedBatchnoIndex);
         });
      },
      // 验收人验证
      async userVerification() {
         var pscadSeccherObj = {
            opmAccount: this.reviewUserInfo.selectIndex,
            passWord: this.reviewUserInfo.passWord,
         };

         let res = await this.$http.reviewVerification(pscadSeccherObj);
         if (res.status == 200) {
            this.reviewUserInfo.selectIndex = res.result.opmName
            this.dialogFormVisible = false;
         } else {
            this.$message({
               message: res.message,
               type: "error",
            });
         }
      },
      // 获取抽检数量
      async samplingRulesQueryCount(num, spec,bgmId) {
         let obj = {
            numbers: num, //	件数
            packingSpec: spec, //	装箱规格
            bgmId: bgmId, //	装箱规格
            yslx: 0,
         }
         let responseData = await this.$http.samplingRulesQueryCount(obj);
         if (responseData.status == 200) {
            return responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
            return false;
         }
      },

      // 获取验收人
      async getSpecialUserTwo() {
         let responseData = await this.$http.getSpecialUser({
            opmAcceptor: 1
         });
         if (responseData.status == 200) {
            this.userTwoList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取供货员
      async getSpecialUser() {
         let responseData = await this.$http.getSpecialUser({
            opmBuyer: 1
         });
         if (responseData.status == 200) {
            this.userOneList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取所有可用库房列表
      async getAllStorageRoom() {
         let responseData = await this.$http.getAllStorageRoom();
         if (responseData.status == 200) {
            this.storageRoomList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //初始化操作
      initActionBox() {
         for (let key in this.sendDataInfo) {
            if (key == "drtchaDetails") {
               this.sendDataInfo[key] = [];
            } else {
               this.sendDataInfo[key] = "";
            }
         }
         this.sendDataInfo.drtchaDetails = [];
         this.filterTableData = [];
         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.totalCount = 0;
      },
      //接收父组件传值
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         this.filterMainField();
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            console.log(123456);
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
               if (key == "drtchaDetails") {
                  for (const key1 in dataInfo[key]) {
                     console.log(key1);
                     this.$set(this.filterTableData, key1, dataInfo[key][key1])
                  }
               }
            }
            this.sendDataInfo.drtchaDetails.forEach((v, i) => {
               v.in = i;
            });
            this.filterTableData = this.sendDataInfo.drtchaDetails;
            if (this.filterTableData.length > 0) {
               this.filterTableData.forEach(item => {
                  item.checkState = 2
               })
               this.$nextTick(() => {
                  this.nextFocus(this.seIndex);
                  this.selectedDetailsIndex = 0
                  setTimeout(() => {
                     let refsElTable = this.$refs.mxTableRef
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]);
                     this.msgCellClick(this.filterTableData[this.selectedDetailsIndex])
                  }, 16.7)
               });
            }
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
               if (key == "drtchaDetails") this.filterTableData = dataInfo[key];
            }
            if (this.filterTableData.length > 0) {
               this.filterTableData.forEach(item => {
                  item.checkState = 2
               })
               this.$nextTick(() => {
                  this.nextFocus(this.seIndex);
                  this.selectedDetailsIndex = 0
                  setTimeout(() => {
                     let refsElTable = this.$refs.mxTableRef
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(this.filterTableData[this.selectedDetailsIndex]);
                     this.msgCellClick(this.filterTableData[this.selectedDetailsIndex])
                  }, 16.7)
               });
            }
         }
         this.drtchacBatchDetails.push(JSON.parse(JSON.stringify(this.phObj)));
         this.getHeight()
      },
      getHeight() {
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.$refs['tree'].init(this.sendDataInfo.pscamId)
                  this.mxHeight = this.$common.getHeight()
               }
            }, 100)
            this.initFocus();
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         var mxFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               mxFormList.push(item);

            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         this.mxForm = mxFormList[0].jurconfigform;
         this.phForm = mxFormList[1].jurconfigform;
         this.phForm.forEach(item => {
            if (item.focusField == 'keydown') {
               this.keydownField = item.entityField
            }
            if (item.fieldType == 'number') {
               if (item.defaultValue) {
                  this.$set(this.phObj, item.entityField, Number(item.defaultValue))
               } else {
                  this.$set(this.phObj, item.entityField, 0)
               }
            } else if (item.fieldType == 'string') {
               if (item.entityField == 'inspReport') {
                  if (item.defaultValue) {
                     this.$set(this.phObj, item.entityField, item.defaultValue)
                  } else {
                     this.$set(this.phObj, item.entityField, [])
                  }
               } else {
                  if (item.defaultValue) {
                     this.$set(this.phObj, item.entityField, item.defaultValue)
                  } else {
                     this.$set(this.phObj, item.entityField, "")
                  }
               }
            } else if (item.fieldType == 'radio') {
               this.$set(this.phObj, item.entityField, Number(item.defaultValue))
            } else {
               if (item.defaultValue) {
                  this.$set(this.phObj, item.entityField, item.defaultValue)
               } else {
                  this.$set(this.phObj, item.entityField, "")
               }
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "drtchaDetails" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.filterTableData = []
      },
      async querySamRule() {
         const res = await this.$http.samplingRulesQuerySamRule({ yslx: 0 })
         if (res.status == 200) {
            this.popTitle = res.result
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.openBox();
      this.getSpecialUser();
      this.getSpecialUserTwo();
      this.getAllStorageRoom();
      this.querySamRule()
      this.$dbCache.Record_Get(9).then((res) => {//采购验收必须要填写抽检数量校验
         //抽检数量拦截
         let obj = res
         if (obj.isEnable == 1) this.detailRules1 = true;
      });
      this.getTimestamp()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      this.ppId = "drtId";
      addEventListener('keyup', this.keyUp)//创建监听键盘事件
      addEventListener('keyup', this.keyUpEnter)//创建监听键盘事件
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() {
      removeEventListener('keyup', this.keyUp)
      removeEventListener('keyup', this.keyUpEnter)
   }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   /* padding-right: 20px; */
}

.pihaoDialog .el-dialog {
   min-height: 60%;
}

.el-drawer {
   outline: none;
}

#dia .el-date-editor.el-input,
#dia .el-date-editor.el-input__inner {
   width: 100% !important;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
   background-color: #fff;
   color: #333;
}

::v-deep
   .el-radio-button__orig-radio:disabled:checked
   + .el-radio-button__inner {
   background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
   color: #333;
}

/* 上传图片 */
.upload {
   width: 200px;
   list-style: none;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}
.upload li {
   position: relative;
   width: 42px;
   height: 42px;
   margin-right: 5px;
   margin-bottom: 5px;
   border: 1px solid #dedede;
}
.upload .active_li {
   border: none;
}
.image_label {
   display: block;
   width: 42px;
   height: 42px;
}
.upload li:last-child {
   border: none;
}
.upload li:last-child .image_label {
   border: 1px dashed #838383;
}
.upload li:last-child .image_label:hover {
   border: 1px dashed #409eff;
   cursor: pointer;
}
.upload li:last-child:hover .icon {
   color: #409eff;
}
.upload li .icon {
   color: #838383;
   font-size: 20px;
   margin: 10px 0 0 10px;
}
.del {
   display: none;
   position: absolute;
   top: 0px;
   right: 0px;
   font-size: 14px;
   z-index: 99;
   cursor: pointer;
}

.del:hover {
   color: #409eff;
}

.upload li:hover .del {
   display: inline-block;
}
::v-deep .el-image__error {
   font-size: 7px;
}
::v-deep .cus-image {
   width: 40px !important;
   height: 40px !important;
}
::v-deep .cus-image img {
   width: 40px !important;
   height: 40px !important;
}

/*  */
.elButton {
   cursor: pointer;
   padding: 7px 10px !important;
   font-size: 12px !important;
   background-color: #409eff;
   color: #ffffff;
   line-height: 14px;
   margin-right: 5px;
   border-radius: 3px;
   margin-left: 10px;
   box-sizing: border-box;
}
.upload_ul {
   width: 280px;
   list-style: none;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}
.upload_ul li {
   position: relative;
   width: 22px;
   height: 22px;
   margin-right: 3px;
   margin-bottom: 3px;
   border: 1px solid #dedede;
}
.upload_ul li .del {
   display: none;
   position: absolute;
   top: -1px;
   right: -1px;
   font-size: 10px;
   z-index: 99;
   cursor: pointer;
}
.upload_ul li .del:hover {
   color: #409eff;
}
.upload_ul li:hover .del {
   display: inline-block;
}
.upload_ul li ::v-deep .el-image__error {
   font-size: 5px;
}
.upload_ul li ::v-deep .cus-image {
   width: 20px !important;
   height: 20px !important;
}
.upload_ul li ::v-deep .cus-image img {
   width: 20px !important;
   height: 20px !important;
}
</style>